import React from 'react';
import PropTypes from 'prop-types';

const Dot = ({ color = '#FF8C00' }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/10px-(All-icons)/dot"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <circle id="Oval" fill={color} fillRule="nonzero" cx="5" cy="5" r="4" />
        </g>
    </svg>
);

Dot.propTypes = {
    color: PropTypes.string,
};

export default Dot;
